export const MAX_INPUT_LENGTH = 255;
export const MAX_INPUT_LENGTH_MEDIUM = 400;
export const MAX_LINK_COUNT = 300;
export const MAX_LINK_COUNT_LARGE = 150;
export const MAX_LINK_COUNT_SMALL = 30;
export let RightsToOrganizationSelection;

(function (RightsToOrganizationSelection) {
  RightsToOrganizationSelection["Owner"] = "owner";
  RightsToOrganizationSelection["Representor"] = "representor";
  RightsToOrganizationSelection["IntellectualProperty"] = "intellectual_property";
  RightsToOrganizationSelection["Individual"] = "individual";
  RightsToOrganizationSelection["TrustedFlagger"] = "trusted_flagger";
  RightsToOrganizationSelection["Organization"] = "organization";
})(RightsToOrganizationSelection || (RightsToOrganizationSelection = {}));

export let RightsToOrganization;

(function (RightsToOrganization) {
  RightsToOrganization["Owner"] = "owner";
  RightsToOrganization["Agent"] = "agent";
  RightsToOrganization["Lawyer"] = "lawyer";
  RightsToOrganization["IpOwner"] = "intellectual_property_owner";
  RightsToOrganization["IpAgent"] = "intellectual_property_agent";
  RightsToOrganization["IpLawyer"] = "intellectual_property_lawyer";
  RightsToOrganization["Individual"] = "individual";
  RightsToOrganization["TrustedFlagger"] = "trusted_flagger";
  RightsToOrganization["Organization"] = "organization";
})(RightsToOrganization || (RightsToOrganization = {}));

export let ReportReasonType;

(function (ReportReasonType) {
  ReportReasonType["IntellectualProperty"] = "intellectual_property";
  ReportReasonType["OtherIllegal"] = "other_illegal";
  ReportReasonType["Unsafe"] = "unsafe";
})(ReportReasonType || (ReportReasonType = {}));

export let IntellectualPropertyCategory;

(function (IntellectualPropertyCategory) {
  IntellectualPropertyCategory["Copyright"] = "copyright";
  IntellectualPropertyCategory["Trademark"] = "trademark";
  IntellectualPropertyCategory["Design"] = "design";
  IntellectualPropertyCategory["Patent"] = "patent";
  IntellectualPropertyCategory["Other"] = "other";
})(IntellectualPropertyCategory || (IntellectualPropertyCategory = {}));

export let IllegalContentType;

(function (IllegalContentType) {
  IllegalContentType["Item"] = "item";
  IllegalContentType["User"] = "user";
  IllegalContentType["Message"] = "message";
  IllegalContentType["MessageFeedback"] = "message_feedback";
})(IllegalContentType || (IllegalContentType = {}));